<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="12">
              <el-textarea
                label="Informacinio / klaidos pranešimo pavadinimas (LT)"
                v-model="formData.text_lt"
                :readonly="modeReadonly"
                :maxlength="1000"
                required
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-textarea
                label="Informacinio / klaidos pranešimo pavadinimas (EN)"
                v-model="formData.text_en"
                :readonly="modeReadonly"
                :maxlength="1000"
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-textarea
                autocomplete="off"
                label="Panaudos komentaras"
                type="text"
                :readonly="modeReadonly"
                v-model="formData.comment"
                :maxlength="1000"
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-autocomplete
                required
                :items="classifiers.application"
                enums
                :disabled="!!getId"
                itemvalue="value"
                itemtext="text"
                label="Aplikacija"
                v-model="formData.application"
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-autocomplete
                required
                :items="classifiers.errorMessagesTypes"
                enums
                :disabled="!!getId"
                itemvalue="value"
                itemtext="text"
                label="Tipas"
                v-model="formData.type"
              />
            </v-col>
            <v-col cols="12" md="6" lg="4">
              <el-text-field
                label="Kodas"
                required
                :disabled="!!getId"
                v-model="formData.code"
                :maxlength="20"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import Enums from '@/enums'
export default {
  name: 'AdminErrorNotificationForm',

  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
      classifiers: [],
    }
  },
  computed: {
    modeReadonly() {
      return false
    },
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti informacinį / klaidos pranešimą`)
      } else {
        return this.$t(`Naujas informacinis / klaidos pranešimas`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    this.getClassifiers()
    if (this.getId) {
      this.getData()
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'classifierErrorNotifications' })
    },
    getClassifiers() {
      this.classifiers = Enums
    },
    getData() {
      this.pageloading = true

      this.$axios
        .get(`notifications/${this.getId}`)
        .then((res) => {
          this.formData = res.data.notification
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },

    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          let url = `notifications`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
             this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
